export const PERIOD_UNIT = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
};
